import React from 'react';
import { Calendar, Clock, ArrowRight } from 'lucide-react';

const BlogCard = ({ post }) => {
  return (
    <article className="blog-card reveal">
      <div className="blog-image-wrapper">
        <img src={post.image} alt={post.title} className="blog-image" />
        <div className="blog-category">{post.category}</div>
      </div>
      
      <div className="blog-content">
        <div className="blog-meta">
          <span className="blog-meta-item">
            <Calendar size={16} />
            {post.date}
          </span>
          <span className="blog-meta-item">
            <Clock size={16} />
            {post.readTime}
          </span>
        </div>
        
        <h3 className="blog-title">{post.title}</h3>
        <p className="blog-excerpt">{post.excerpt}</p>
        
        <button className="blog-read-more">
          Read Article
          <ArrowRight size={18} />
        </button>
      </div>
    </article>
  );
};

export default BlogCard;
